'use strict'

define ["./sidebar.jade"], (SidebarTemplate) ->
  (RentappService) ->
    restrict: "E"
    template: SidebarTemplate
    link: (scope, element, attrs) ->
      scope.toClassic = () ->
        RentappService.enableClassic()
        .then ->
          window.location.href =  window.location.protocol + "//" + window.location.host + '/dashboard?classic=true'





// WEBPACK FOOTER //
// ./directives/sidebar/sidebar.coffee